import { GreenBold } from 'components/Tables/ActivityTableV2/CellEvent/CellEventFormatter'
import { CellEventFormatterProps } from '../../utils'

export const DocumentCreateEvent = ({ event }: CellEventFormatterProps) => {
  // Check if this is a replacement by looking at document_is_replacement flag
  const firstField = event.field_history_objects?.[0]
  const isReplacement = firstField?.document_is_replacement

  if (isReplacement) {
    return (
      <>
        replaced a <GreenBold>document</GreenBold>
      </>
    )
  }

  return (
    <>
      created new <GreenBold>document</GreenBold>
    </>
  )
}
